import { AppData, Log, Utils } from '@lightningjs/sdk'
import { Helper } from '../lib/helper'
import { PlatformBase } from './platform-base'
import { getDeviceIp, getSiteConfig, initSecurityToken } from '../lib/models/data-service'
import { KeyCodes } from '../lib/key-codes'
import { AppSetup } from '../lib/app-setup'
import { Logger } from '../lib/logger'
import VideoScreen from '../pages/video-screen'
import Router from '@lightningjs/sdk/src/Router'
import { AppApiConfig } from '../lib/app-api-config'

export class PlatformSamsung extends PlatformBase {
  systemApi: any = null
  appSuspendedTime = 0
  isVideoSuspended = false
  isInitialized = false
  visibilityTimerIndex = null
  lastVisibilityState = ''
  constructor() {
    super()
    this._setKeys()
    this.keyMap = {
      413: 'Stop',
      415: 'Play',
      19: 'Pause',
      412: 'Rewind',
      417: 'Forward',
      418: 'Next',
      419: 'Previous',
      10182: 'Exit',
      10009: 'Back',
      10252: 'XF86PlayBack',
    }
  }

  override setKeyMappings(appSettings: any) {

    const registerKeyList = [
      'ColorF3Blue',
      'MediaPlayPause',
      'MediaRewind',
      'MediaFastForward',
      'MediaPlay',
      'MediaPause',
      'MediaStop',
      'MediaTrackPrevious',
      'MediaTrackNext',
      'Caption',
      'Exit',
      'Info'
    ]
    if (window.tizen) {
      window.tizen.tvinputdevice.registerKeyBatch(registerKeyList)
    }
    appSettings.keys = this.keyMap
  }

  override _setKeys() {
    KeyCodes.KEY_STOP = 413;
    KeyCodes.KEY_PLAY = 415;
    KeyCodes.KEY_PLAYPAUSE = 10252; //XF86PlayBack
    KeyCodes.KEY_PAUSE = 19;
    KeyCodes.KEY_REWIND = 412;
    KeyCodes.KEY_FORWARD = 417;
    KeyCodes.KEY_NEXT = 418;
    KeyCodes.KEY_PREVIOUS = 419;
    KeyCodes.KEY_BACK = 10009;
    KeyCodes.KEY_EXIT = 10182;
  }

  setupVizibilityListener() {
    document.addEventListener("visibilitychange", this.handleMultiTaskingAppSwitching.bind(this));
    this.lastVisibilityState = document.visibilityState //setting the last visibility state to current visibility
  }

  override remapSiteId(siteId: string): string {
    return siteId == '236' ? '1285' : siteId
  }

  override async initialize(): Promise<boolean> {
    this.isInitialized = true
    this._shouldShowExitPopup = true
    const { appState, appConfig } = AppData as AppSetup
    const app = appState?.getApp()!
    if (app.siteId == '236') {
      appConfig.siteId = '1285'
      app.siteId = '1285'
    }
    appConfig.enableCCSettings = true
    appConfig.enableRetries = true
    appConfig.enableNetworkDisconnectionCheck = true
    Log.info('PlatformBase:', typeof this)
    this._siteConfig = await getSiteConfig()
    Log.info('PlatformBase: siteConfig: ', this._siteConfig)
    // commented the code for enabling live tv for Samsung
    //appConfig.enableLiveRow = false //disabling the live tv for this build.
    Helper.getSiteConfigInfo(this._siteConfig)


    if (appConfig.enableSecurityToken) {
      appConfig?.apiVersion = "sv9.0";
      var securityToken = Helper.getCookie("_token");
      if (securityToken) {
        appConfig.securityToken = securityToken;
      } else {
        var securityTokenAPIResp = await initSecurityToken();
        appConfig.securityToken = securityTokenAPIResp.securityToken;
        Helper.setGeneralCookie("_token", appConfig.securityToken, 1);
      }
    }

    window.addEventListener('appcontrol', (event) => {
      Log.info('PlatformBase: appcontrol ', event)
      if (event && event.type == 'appcontrol') {
        let payload = this.getPayloadData()
        this.handleDeeplinkInturrep(payload)
      }
    });
    return new Promise(async (resolve, reject) => {

      Log.info('PlatformBase:', typeof this)
      if (window.webapis) {
        const webapis = window.webapis
        try {
          this._firmwareVersion = webapis.productinfo.getFirmware(); //shows OS version. use this
        } catch (e) { }
        try {
          this._deviceId = webapis.productinfo.getDuid(); //Unique id for smart hub (not tv serial number). use this
        } catch (e) {
          //on the Emulator, this API returns error. henece, setting the the deviceId to static string
          this._deviceId = 'EMULATOR12345'
        }
        if (webapis && webapis.adinfo) {
          this._ifa = webapis.adinfo.getTIFA()
          this._ifaType = 'tifa'
          //Fix for XFIN-1201
          //this._limitAdTracking = webapis.adinfo.isLATEnabled().toString()
          let lmt = webapis.adinfo.isLATEnabled();
          if (lmt === true) {
            this._limitAdTracking = '1';
          } else {
            this._limitAdTracking = '0';
          }
        }
        this._fullModel = webapis.productinfo.getRealModel();

      }
      //this.logAllDeviceParams()
      this.setupVizibilityListener()
      resolve(true)
    })
  }

  handleDeeplinkInturrep(payload) {
    Log.info('handleDeeplinkInturrep: ', payload)
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()!
    const route = Router.getActiveRoute()!
    if (route.indexOf('video') > -1) {
      const page: VideoScreen = Router.getActivePage()
      page.hitCloseTracker()
      page.closeVideo(true)
      app?.handleBackNavigation();
    }
    //fix for IPTV-2085
    while (app.navigation.continuesStack.length > 1) {
      app.navigation.pop()
    }
    app.loadDeeplinkInterrupt(payload)
  }

  handleMultiTaskingAppSwitching(event) {
    Log.info('visibilitychange: ', document.visibilityState)
    console.log('visibilitychange: visibilityState, doc.hidden : ', document.visibilityState, document.hidden)

    // if (this.visibilityTimerIndex) {
    //   clearTimeout(this.visibilityTimerIndex)
    // }
    //this.visibilityTimerIndex = setTimeout(() => {
      
      if (document.visibilityState === 'hidden') { // && this.lastVisibilityState !== document.visibilityState) {
        this.handleAppSuspend()
      } if (document.visibilityState === 'visible') { // && this.lastVisibilityState !== document.visibilityState) {
        this.handleAppResume()
      }
      this.lastVisibilityState = document.visibilityState
    //}, 100)
  }

  handleAppSuspend() {
    //on app suspended we mark current time 
    const { appState } = AppData as AppSetup;
    const route = Router.getActiveRoute()!
    const app = appState?.getApp()
    this.appSuspendedTime = new Date().getTime()
    console.log('visibilitychange: App suspended,', document.visibilityState, document.hidden, this.appSuspendedTime)
    appState.appUnload = true
    if (route.indexOf('video') > -1) {
      this.isVideoSuspended = true
      const page: VideoScreen = Router.getActivePage()
      app.suspendedAppStack = [...app.navigation.continuesStack]
      //page.handleInactiveEvent()
      page.hitCloseTracker()
      page.closeVideo(true, true)
      app?.handleBackNavigation();
    }
    Logger.processUserAction('userExitedViaRemoteDirectly', 'App_Suspended')
  }

  handleAppResume() {
    const { appConfig, appState } = AppData as AppSetup;
    //on appResume we will clear 
    const timeDiff = new Date().getTime() - this.appSuspendedTime
    const wakeupTime = Helper.secondsToHms(Math.round(timeDiff / 1000), true)
    //console.log('visibilitychange: App Resume,', document.visibilityState, document.hidden, wakeupTime)
    if (timeDiff >= appConfig?.appResumeReloadTime) {
      Logger.processUserAction('appResumedFromSuspend', 'App_Refresh_' + wakeupTime)      
      try {
        Router.getActivePage().widgets.loadingscreen.showLoadingScreen(true)
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      } catch (e) {
        Log.info('Issue setting showLoadingScreen')
      }      
    } else {
      appConfig.sessionId = Helper.generateSessionId();
      Log.info('appResumed: sessionId', appConfig.sessionId)
      Logger.processUserAction('appResumedFromSuspend', 'App_Resumed_' + wakeupTime)
      this.logAllDeviceParams()
      this.appSuspendedTime = null
      let payload = this.getPayloadData()
      if (payload) {
        this.isVideoSuspended = false
        this.handleDeeplinkInturrep(payload)
      } else {
        this.handleResume()
      }
    }
  }


  // async checkBuildVersionChange() {
  //   const { appConfig } = AppData as AppSetup
  //   const {tizen, environment, _rootConfig} = window
  //   const packageVer=(tizen ?  tizen.package.getPackageInfo().version : '2.0.0')
  //   const _url = environment[_rootConfig.env] + '/?platform_id=' + _rootConfig.auth_token + '&siteId=' + _rootConfig.siteId + '&appVer=' + packageVer;
  //   try {
  //     const resp = await fetch(_url)
  //     let newVer = await resp.text()
  //     newVer = newVer.split('/')[1]!
  //     const curVer = appConfig?.buildVersion
  //     if(curVer !== newVer) {
  //       return true
  //     }
  //   } catch(e) {
  //     return false
  //   }
  // }

  async handleResume() {
    // const isVersionChange = await this.checkBuildVersionChange()
    // if(isVersionChange) {
    //   window.location.reload()
    //   return;
    // }
    //Sending the source info to the logger as instance-resume string
    Logger.logSourceInfo(true)
    // fix for IPTV-2189
    if (this.isVideoSuspended) {
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      app.navigation.continuesStack = [...app.suspendedAppStack]
      app.suspendedAppStack = []
      const vodInfo = app.navigation.getCurrentVodInfo()
      if (vodInfo.actiontype == 'live') {
        Router.navigate('video-screen-live/' + vodInfo.node_id + '_resume', false)
      } else {
        Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false)
      }
    }
    this.isVideoSuspended = false
  }

  override sendMetrics(eventType: string, dataObj: any) {
    Log.info('Send Metrics:', eventType, dataObj)
    switch (eventType) {
      case 'launch':
        this.logAllDeviceParams()
        break;
      case 'close':
        Logger.processUserAction('userExitedAppUsingExitWindow');
        setTimeout(() => {
          if (window.tizen) {
            window.tizen.application.getCurrentApplication().exit();
          }
        })
        break;
    }
  }

  getPayloadData() {
    let payload = null;
    const { tizen, devParams } = window

    const reqAppControl = tizen && tizen.application.getCurrentApplication().getRequestedAppControl();
    if (devParams && devParams.debug && devParams.playId !== '') {
      let pObj = { values: devParams.playId }
      if (reqAppControl && reqAppControl.appControl) {
        const pl = new tizen.ApplicationControlData('PAYLOAD', [JSON.stringify(pObj)]);
        reqAppControl.appControl.data.push(pl);
      }
    }
    try {
      if (reqAppControl && reqAppControl.appControl) {
        var appControlData = reqAppControl.appControl.data;
        const rawDataValues = [{ key: 'callerAppId', value: reqAppControl.callerAppId, _previouslyConstructed: '' }]
        for (var i = 0; i < appControlData.length; i++) {
          const key = appControlData[i].key
          const value = encodeURIComponent(appControlData[i].value[0])
          const previouslyConstructed = appControlData[i]._previouslyConstructed
          rawDataValues.push({ key: key, value: value, _previouslyConstructed:  previouslyConstructed})
          if (appControlData[i].key == 'PAYLOAD') {
            var pdataStr = appControlData[i].value[0];
            //app.payloadStr = pdataStr;
            //app.appState.deeplinks.payloadStr = pdataStr;
            payload = JSON.parse(pdataStr).values;
          }
        }
        Logger.processUserAction('deeplinkRawDataFromPlatform', JSON.stringify(rawDataValues))
        Log.info('DeeplinkRawDataFromPlatform:', rawDataValues)
      }
    } catch (e) {
      // TODO: handle exception
    }
    if (!payload) {
      return null;
    }
    let jsonData = JSON.parse(payload);
    let finalData = this.parseDeeplinkData(jsonData);
    if (devParams.debug) {
      if ($('#deeplink-disp-div')[0]) {
        $('#deeplink-disp-div').text('Paylod data: ' + finalData)
      } else {
        $('body').append('<div id="deeplink-disp-div" style="position: absolute;top: 80px;z-index: 999999;background-color: #000;color: #fff;font-size: 1.6em;">Paylod data: ' + finalData + '</div>')
      }
    }
    return finalData;
  }

  parseDeeplinkData = (data) => {
    let params = '';
    let arr = [];
    if (data && data.assetId) {
      let paramStr = atob(data.assetId);
      let paramObj = JSON.parse(paramStr);
      for (let key in paramObj) {
        arr.push(`${key}=${paramObj[key]}`);
      }
      // if (data.src) {
      //     arr.push(`src=${data.src}`);
      // }
    } else if (data && data.playId) {
      arr.push('playId=' + data.playId);
    }
    if (data.src) {
      arr.push(`src=${this._getDeeplinkType(data.src)}`);
    }
    if (arr.length > 0) {
      params = '?' + arr.join('&');
    }
    return params;
  }

  _getDeeplinkType(dType: string): string {
    switch (dType) {
      case 'search':
        return 'hs-search'
      case 'promo':
        return 'hs-d'
      case 'preview':
        return 'recommendationbytheapp'
      default:
        return 'hs-search'
    }
  }

  override getPlatformDeeplinkData(): Promise<string> {
    return new Promise((resolve, reject) => {
      let payload = this.getPayloadData()
      // check the deeplink params at Home launch / first launch.
      if (payload) {
        resolve(payload)
      } else {
        resolve('')
      }
    })
  }

  // override getAppStoreId(indexObj: any): string {
  //   if (indexObj && indexObj?.vizioAppId) return indexObj?.vizioAppId
  //   return ''
  // }

  getDeviceApi(apiName: any, api: any, responseType: any): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        const response = api()
        let resp = `${apiName}=`
        if (responseType == 'json') {
          const results = []
          let isEmpty = true
          for (const [key, value] of Object.entries(response)) {
            let val = value
            isEmpty = false
            if (value && value.readable) {
              val = value.readable
            }
            results.push(`${key}:${val}`)
          }
          if (!isEmpty) {
            resp += results.join(',')
          }
        } else if (responseType == 'array') {
          resp += response.join(',')
        } else if (responseType == 'string') {
          resp += (response instanceof Object) ? '' : response
        }
        if (apiName == 'platformVersion') {
          Logger.processUserAction('productVersion', response)
        }
        resolve(resp)
      }
      catch (error) {
        if (apiName == 'platformVersion') {
          Logger.processUserAction('productVersion', 'apiError')
        }
        resolve(`${apiName}=apiError`)
      }
    })
  }

  logAllDeviceParams() {
    return new Promise((resolve, reject) => {
      const { appState } = AppData as AppSetup
      const appApiConfig = appState?.getAppApiConfig() as AppApiConfig
      const deviceInfo = {
        // hdcp: { api: Device.hdcp, responseType: 'json' },
        // hdr: { api: Device.hdr, responseType: 'json' },
        id: { api: () => webapis.productinfo.getDuid(), responseType: 'string' },
        framework: { api: () => webapis.productinfo.getFirmware(), responseType: 'string' },
        model: { api: () => webapis.productinfo.getModel(), responseType: 'string' },
        modelCode: { api: () => webapis.productinfo.getModelCode(), responseType: 'string' },
        realmodel: { api: () => webapis.productinfo.getRealModel(), responseType: 'string' },
        platformVersion: { api: () => tizen.systeminfo.getCapability('http://tizen.org/feature/platform.version'), responseType: 'string' },
        platformVersionName: { api: () => tizen.systeminfo.getCapability('http://tizen.org/feature/platform.version.name'), responseType: 'string' },
        graphicAccl: { api: () => tizen.systeminfo.getCapability('http://tizen.org/feature/graphics.acceleration'), responseType: 'string' },
        screenWidth: { api: () => tizen.systeminfo.getCapability('http://tizen.org/feature/screen.width'), responseType: 'string' },
        screenHeight: { api: () => tizen.systeminfo.getCapability('http://tizen.org/feature/screen.height'), responseType: 'string' },
        systemMemory: { api: () => Math.round(tizen.systeminfo.getTotalMemory() / 1024 / 1024) + 'MB', responseType: 'string' },
        country: { api: () => appApiConfig.userConfig.countryCode, responseType: 'string'},
        region: { api: () => appApiConfig.userConfig.regionName, responseType: 'string'},
        city: { api: () => appApiConfig.userConfig.cityName, responseType: 'string'}
        


        // make: { api: Device.make, responseType: 'string' },
        // model: { api: Device.model, responseType: 'string' },
        // name: { api: Device.name, responseType: 'string' },
        // network: { api: Device.network, responseType: 'json' },
        // platform: { api: Device.platform, responseType: 'string' },
        // screenResolution: { api: Device.screenResolution, responseType: 'array' },
        // sku: { api: Device.sku, responseType: 'string' },
        // type: { api: Device.type, responseType: 'string' },
        // uid: { api: Device.uid, responseType: 'string' },
        // videoResolution: { api: Device.videoResolution, responseType: 'array' },
        // version: { api: Device.version, responseType: 'json' }
      }

      const results: Promise<string> = []
      for (const [key, value] of Object.entries(deviceInfo)) {
        results.push(this.getDeviceApi(key, value.api, value.responseType))
      }
      Promise.all(results).then(dataList => {
        const results = dataList.join('&')
        Logger.processUserAction('deviceInfo', encodeURIComponent(results))
        resolve(true)
      })
    })
  }

  override getOptionsIconPath(apiOptionsIcon: string | undefined) {
    // if(apiOptionsIcon && apiOptionsIcon !== '') {
    //   return apiOptionsIcon
    // }
    return Utils.asset('/images/option-blue.png')
  }

  override getAppStoreId(type = ''): string {
    const { appState } = AppData as AppSetup
    const appApiConfig = appState?.getAppApiConfig()
    if (type == 'ad') {
      if (appApiConfig && appApiConfig.appConfig.samsungAppStoreId) {
        return appApiConfig.appConfig.samsungAppStoreId
      }
    } else if (appApiConfig && appApiConfig.appConfig.samsungAppId) {
      return appApiConfig.appConfig.samsungAppId
    }
    return ''
  }

  override isOptionsKey(e: KeyboardEvent): boolean {
    // console.log('isOptionsKey: ', e)
    if (e.keyCode == KeyCodes.KEY_BLUE || e.code == 'KeyB') {
      return true
    }
    return false
  }

  override getOptionsText() {
    return 'Press Blue for Options'
  }

  override getScript(platformSettings): string[] {
    return [
      platformSettings.path + 'modules/hlsjs/hls.min.js',
      platformSettings.path + 'modules/dashjs/dash.all.min.js',
    ]
  }

  override getAppOptions(appSettings: any, platformSettings: any) {
      let tizenVersion = (tizen ? tizen.systeminfo.getCapability("http://tizen.org/feature/platform.version") : '5.5' );
      let majorVersion = parseInt(tizenVersion.split('.')[0]);
      
      let memoryPressure = 16e6 //mid range and safe range for most apps. 18 Mpix
      let textureMemory = 256 * 1024 * 1024 //texture memory size
      if(majorVersion <= 3 ) {
        memoryPressure = 12e6 //12 Mpix
        textureMemory = 128 * 1024 * 1024
      } else if(majorVersion >= 6) {
        memoryPressure = 24e6 //24 Mpix
        textureMemory = 512 * 1024 * 1024
      }

      const canvas = document.createElement('canvas')
      const vw = window.screen.width;   //less safeFrame
      const vh = window.screen.height; //less safeFrame
      //const scalling:any = vh == 1080 ? 1 : ((vh / 1080).toPrecision(7));
      canvas.setAttribute('width','1920')
      canvas.setAttribute('height','1080')
      canvas.setAttribute('style', 'position: absolute;z-index: 2;width: 100vw;height: 100vh;')
      appSettings.stage.useImageWorker = false
      appSettings.stage.canvas = canvas
      const precision=1
      appSettings.stage.w = 1920 
      appSettings.stage.h = 1080
      appSettings.stage.precision = precision
      appSettings.stage.memoryPressure = memoryPressure
      appSettings.stage.textureMemory = textureMemory
      window.platformSettings = platformSettings as PlatformSettings
  }

  override getHlsOptions(): any {
    // 1. Get the Tizen Platform Version
    const tizenVersion = tizen.systeminfo.getCapability("http://tizen.org/feature/platform.version");
    const majorVersion = parseInt(tizenVersion.split('.')[0]);

    // 2. Fallback check for Model Name (to identify high-end vs low-end hardware)
    var modelName = webapis.productinfo.getModel();

    // Baseline for 2025 (Tizen 8.0/9.0) or High-end models
    var config = {
      enableWorker: false, // Essential for all Tizen models
      maxBufferLength: 25,
      maxBufferSize: 30 * 1000 * 1000, // 30MB
      // CRITICAL: Set to a small value (1-2s) instead of 0. 
      // Setting to 0 can stop Tizen from effectively flushing old segments.
      backBufferLength: 2, 
      
      // --- STALL & GAP RECOVERY ---
      // Ensure nudgeOffset <= maxBufferHole to prevent infinite fetch loops.
      maxBufferHole: 0.5,      // Tolerates small gaps in the timeline
      nudgeOffset: 0.1,        // Smaller steps to find valid frames without skipping too much
      nudgeMaxRetry: 5,        // Stop loop after 5 failed attempts
      
      // Frequency to check if the playhead is stuck while the buffer is actually full.
      highBufferWatchdogPeriod: 3, 

      // --- LOADING STRATEGY ---
      startLevel: 0,           // Start with lowest bitrate to ensure fast startup on TV hardware
      appendErrorMaxRetry: 3,  // Prevents the player from looping on a corrupted segment
      
      // Low latency isn't recommended for older Tizen; disable for stability.
      lowLatencyMode: false 
      
    };

    // Downscale for older hardware (Tizen 5.5 and below / Pre-2021)
    if (majorVersion <= 5) {
      config.maxBufferLength = 15;
      config.maxBufferSize = 20 * 1000 * 1000; // 20MB
    }

    return config;
  }

  //Ad Macros related value mapping functions based on the platform.

  override getAppNameMacro(appName: string): string {
    const { appConfig } = AppData as AppSetup;
    if (appConfig.siteId == '1285') {
      appName = 'Fawesome'
    }
    return appName.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
  }

}
